export default {
  loggedIn: {
    deposit: 'جمع کروائیں',
    withdraw: 'رقم نکالیں',
    balance: 'کل بیلنس',
    cash: 'نقد',
    bonus: 'بونس',
    withdrawable: 'قابل واپسی',
    transaction: 'لین دین',
    history: 'تاریخ',
    myBet: 'My Bet',
    rollover: 'رول اوور',
    vault: 'تجوری',
    notification: 'اطلاع',
    affiliate: 'ملحق - ہر ماہ $5,000 کمائیں',
    affiliateTitle: 'ملحق',
    affiliateBadge: 'ہر ماہ $5,000 کمائیں',
    settings: 'ترتیبات',
    currency: 'کرنسی',
    language: 'زبان',
    liveSupport: 'براہ راست معاونت',
    signOut: 'سائن آؤٹ'
  }
};
